module.exports = __webpack_public_path__ + "img/cloth_g1_shoe_05.b29f5dbf.svg";